import { KeepAlive, nextTick } from "vue"
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
const Home = () => import("@/views/home/index.vue")
const Layout = () => import("@/layout/index.vue")

/** 常驻路由 */
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: "/loginChoose",
    component: () => import("@/views/login/index.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        component: Home,
        name: "Home",
        meta: {
          title: "营城丨城市空间资产经营信息平台",
          bottomNavShow: true,
          keepAlive: true,
          catch: true
        },
        beforeEnter: (to: any, from: any, next: any) => {
          if (
            from.path == "/resource/detail" ||
            from.path == "/resource/plazaGC" ||
            from.path == "/resource/map" ||
            from.path == "/resource/mapNew" ||
            from.path == "/policy" ||
            from.path == "/projectDemand" ||
            from.path == "/resource/search" ||
            from.path == "/" ||
            from.path == "/home" ||
            from.path == "/user" ||
            from.path == "/projectDemand/publishDemand"
          ) {
            // 不需要刷新
            to.meta.keepAlive = false
            next()
          } else {
            // 需要刷新
            to.meta.keepAlive = true
            next()
          }
        }
      },
      {
        path: "/resource/map",
        component: () => import("@/views/resource/map.vue"),
        name: "ResourceMap",
        meta: {
          title: "资源地图",
          keepAlive: false
        }
      },
      {
        path: "/resource/mapNew",
        component: () => import("@/views/resource/mapNew.vue"),
        name: "ResourceMapNew",
        meta: {
          title: "资源地图",
          keepAlive: false
        }
      },
      {
        path: "/resource/plaza",
        component: () => import("@/views/resource/plaza.vue"),
        name: "ResourcePlaza",
        meta: {
          title: "资源广场",
          keepAlive: true,
          catch: true
        },
        beforeEnter: (to: any, from: any, next: any) => {
          if (from.path == "/resource/detail" || from.path == "/" || from.path == "/home") {
            // 不需要刷新
            to.meta.keepAlive = false
            next()
          } else {
            // 需要刷新
            to.meta.keepAlive = true
            next()
          }
        }
      },
      {
        path: "/resource/plazaGC",
        component: () => import("@/views/resource/plazaGC.vue"),
        name: "ResourcePlazaGc",
        meta: {
          title: "资源广场",
          keepAlive: true,
          catch: true
        },
        beforeEnter: (to: any, from: any, next: any) => {
          if (from.path == "/resource/detail" || from.path == "/" || from.path == "/home") {
            // 不需要刷新
            to.meta.keepAlive = false
            next()
          } else {
            // 需要刷新
            to.meta.keepAlive = true
            next()
          }
        }
      },
      {
        path: "/resource/search",
        component: () => import("@/views/resource/search.vue"),
        name: "ResourceSearch",
        meta: {
          title: "营城丨城市空间资产经营信息平台"
        }
      },
      {
        path: "/resource/detail",
        component: () => import("@/views/resource/detail.vue"),
        name: "ResourceDetail",
        meta: {
          title: "资源详情"
        }
      },
      {
        path: "/column",
        component: () => import("@/views/resource/column.vue"),
        name: "Column",
        meta: {
          title: "资源专栏"
        }
      },
      {
        path: "/policy",
        component: () => import("@/views/policy/index.vue"),
        name: "Policy",
        meta: {
          title: "政策资讯",
          keepAlive: true,
          catch: true
        },
        beforeEnter: (to: any, from: any, next: any) => {
          if (from.path == "/policy/detail" || from.path == "/" || from.path == "/home") {
            // 不需要刷新
            to.meta.keepAlive = false
            next()
          } else {
            // 需要刷新
            to.meta.keepAlive = true
            next()
          }
        }
      },
      {
        path: "/policy/detail",
        component: () => import("@/views/policy/policyDetail.vue"),
        name: "PolicyDetail",
        meta: {
          title: "政策详情"
        }
      },
      {
        path: "/projectDemand",
        component: () => import("@/views/projectDemand/index.vue"),
        name: "projectDemand",
        meta: {
          title: "项目需求",
          keepAlive: true,
          catch: true
        },
        beforeEnter: (to: any, from: any, next: any) => {
          console.log(to)
          console.log(from)
          if (from.path == "/projectDemand/detail" || from.path == "/" || from.path == "/home") {
            to.meta.keepAlive = false
            next()
          } else {
            to.meta.keepAlive = true
            next()
          }
        }
      },
      {
        path: "/projectDemand/detail",
        component: () => import("@/views/projectDemand/detail.vue"),
        name: "projectDemandDetail",
        meta: {
          title: "项目需求详情"
        }
      },
      {
        path: "/applayForm",
        component: () => import("@/views/projectDemand/applayForm.vue"),
        name: "applayForm",
        meta: {
          title: "资源申请"
        }
      },
      {
        path: "/projectDemand/publishDemand",
        component: () => import("@/views/projectDemand/publishDemand.vue"),
        name: "publishDemand",
        meta: {
          title: "发布项目需求"
        }
      },
      {
        path: "/user",
        component: () => import("@/views/user/index.vue"),
        name: "user",
        meta: {
          title: "我的",
          bottomNavShow: true
        }
      },
      {
        path: "/userH5",
        component: () => import("@/views/user/indexH5.vue"),
        name: "userh5",
        meta: {
          title: "我的h5",
          bottomNavShow: true
        }
      },
      {
        path: "/codeLogin",
        component: () => import("@/views/login/codeLogin.vue"),
        name: "codeLogin",
        meta: {
          title: "验证码登录"
        }
      },
      {
        path: "/logout",
        component: () => import("@/views/login/logout.vue"),
        name: "logout",
        meta: {
          title: "注销"
        }
      },
      {
        path: "/logins",
        component: () => import("@/views/login/logins.vue"),
        name: "logins",
        meta: {
          title: "logins"
        }
      },
      {
        path: "/personDetail",
        component: () => import("@/views/user/personDetail.vue"),
        name: "personDetail",
        meta: {
          title: "个人信息"
        }
      },
      {
        path: "/nickname",
        component: () => import("@/views/user/nickname.vue"),
        name: "nickname",
        meta: {
          title: "修改昵称"
        }
      },
      {
        path: "/mail",
        component: () => import("@/views/user/mail.vue"),
        name: "mail",
        meta: {
          title: "修改邮箱"
        }
      },
      {
        path: "/authenticationPerson",
        component: () => import("@/views/user/authenticationPerson.vue"),
        name: "authenticationPerson",
        meta: {
          title: "个人信息"
        }
      },
      {
        path: "/authenticationCompany",
        component: () => import("@/views/user/authenticationCompany.vue"),
        name: "authenticationCompany",
        meta: {
          title: "个人信息"
        }
      },
      {
        path: "/myMessage",
        component: () => import("@/views/my/messageList.vue"),
        name: "myMessage",
        meta: {
          title: "我的消息"
        }
      },
      {
        path: "/myPublish",
        component: () => import("@/views/my/publishList.vue"),
        name: "myPublish",
        meta: {
          title: "我的发布"
        }
      },
      {
        path: "/myFeedBack",
        component: () => import("@/views/my/feedBackList.vue"),
        name: "myFeedBack",
        meta: {
          title: "我的反馈"
        }
      },
      {
        path: "/myFeedBack/detail",
        component: () => import("@/views/my/feedBackDetail.vue"),
        name: "feedBackDetail",
        meta: {
          title: "反馈详情"
        }
      },
      {
        path: "/myFeedBack/addFeedBack",
        component: () => import("@/views/my/addFeedBack.vue"),
        name: "addFeedBack",
        meta: {
          title: "新增反馈"
        }
      },
      {
        path: "/myBrowse",
        component: () => import("@/views/my/browseList.vue"),
        name: "myBrowse",
        meta: {
          title: "浏览记录"
        }
      },
      {
        path: "/myCollect",
        component: () => import("@/views/my/collectList.vue"),
        name: "myCollect",
        meta: {
          title: "我的收藏"
        }
      },
      {
        path: "/myComment",
        component: () => import("@/views/my/commentList.vue"),
        name: "myComment",
        meta: {
          title: "我的评论"
        }
      },
      {
        path: "/myApply",
        component: () => import("@/views/my/applylist.vue"),
        name: "myApply",
        meta: {
          title: "申请记录"
        }
      },
      {
        path: "/adoutUs",
        component: () => import("@/views/my/adoutUs.vue"),
        name: "adoutUs",
        meta: {
          title: "关于我们"
        }
      },
      {
        path: "/systemNoticeDetail",
        component: () => import("@/views/my/systemNoticeDetail.vue"),
        name: "systemNoticeDetail",
        meta: {
          title: "系统通知详情"
        }
      },
      {
        path: "/webView",
        component: () => import("@/views/webView/index.vue"),
        name: "webView",
        meta: {
          title: ""
        }
      },
      {
        path: "/xieyi",
        component: () => import("@/views/my/xieyi.vue"),
        name: "xieyi",
        meta: {
          title: "协议"
        }
      },
      {
        path: "/projectIndetail",
        component: () => import("@/views/my/projectIndetail.vue"),
        name: "projectIndetail",
        meta: {
          title: "产品介绍"
        }
      },
      {
        path: "/consultCooperation",
        component: () => import("@/views/my/consultCooperation.vue"),
        name: "consultCooperation",
        meta: {
          title: "咨询合作"
        }
      }
    ]
  }
]

/**
 * 动态路由
 * 用来放置有权限（roles 属性）的路由
 * 必须带有 name 属性
 */
export const asyncRoutes: Array<RouteRecordRaw> = [
  // {
  //   path: "/permission",
  //   component: Layout,
  //   redirect: "/permission/page",
  //   name: "Permission",
  //   meta: {
  //     title: "权限管理",
  //     icon: "lock",
  //     roles: ["admin", "editor"], // 可以在根路由中设置角色
  //     alwaysShow: true // 将始终显示根菜单
  //   },
  //   children: [
  //     {
  //       path: "page",
  //       component: () => import("@/views/permission/page.vue"),
  //       name: "PagePermission",
  //       meta: {
  //         title: "页面权限",
  //         roles: ["admin"] // 或者在子导航中设置角色
  //       }
  //     },
  //     {
  //       path: "directive",
  //       component: () => import("@/views/permission/directive.vue"),
  //       name: "DirectivePermission",
  //       meta: {
  //         title: "指令权限" // 如果未设置角色，则表示：该页面不需要权限，但会继承根路由的角色
  //       }
  //     }
  //   ]
  // },
  {
    path: "/:pathMatch(.*)*", // 必须将 'ErrorPage' 路由放在最后, Must put the 'ErrorPage' route at the end
    component: () => import("@/views/error-page/404.vue"),
    redirect: "/404",
    name: "ErrorPage",
    meta: {
      title: "错误页面",
      icon: "404",
      hidden: true
    },
    children: [
      {
        path: "404",
        component: () => import("@/views/error-page/404.vue"),
        name: "404",
        meta: {
          title: "404"
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})

/** 重置路由 */
export function resetRouter() {
  // 注意：所有动态路由路由必须带有 name 属性，否则可能会不能完全重置干净
  try {
    router.getRoutes().forEach((route: any) => {
      const { name, meta }: any = route
      if (name && meta.roles?.length) {
        router.hasRoute(name) && router.removeRoute(name)
      }
    })
  } catch (error) {
    // 强制刷新浏览器，不过体验不是很好
    window.location.reload()
  }
}
router.beforeEach((to: any, from: any, next: any) => {
  console.log("***********************************************")
  console.log(to.path)
  console.log(from.path)
  if (to.path == "/projectDemand" && from.path == "/home" && !from.redirectedFrom) {
    to.meta.isReach = true
    next()
    // setTimeout(() => {
    //   window.location.reload()
    // }, 0)
  } else if (to.path == "/resource/plazaGC" && from.path == "/home" && !from.redirectedFrom) {
    to.meta.isReach = true
    next()
  } else if (to.path == "/resource/plaza" && from.path == "/home" && !from.redirectedFrom) {
    to.meta.isReach = true
    next()
  } else if (to.path == "/policy" && from.path == "/home" && !from.redirectedFrom) {
    to.meta.isReach = true
    next()
  } else if (to.path == "/home" && from.path == "/user" && !from.redirectedFrom) {
    to.meta.isReach = true
    next()
  } else {
    to.meta.isReach = false
    next()
  }
})
export default router
